import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ValidOtp.css";
import { BiLoader } from "react-icons/bi";
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from "../../authContext/AuthContext";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";


function ValidOtp({validateData,username, password, setValidateData, setShowLoginPage, setShowOtpPage}) {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(180);

  const [showGenerateBtn, setShowGenerateBtn] = useState(false);
  const { setIsAuthenticated, setUserEmail,setPermissions } = useAuth();
  const [isDisabled, setIsDisabled] = useState(true);

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (/[^0-9]/.test(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === 'Backspace' && otp[index] === '') {
      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;


  };
  
  useEffect(() => {
    if(timer === 0){
      // setShowGenerateBtn(true);
      return;
    }
    const intervalTimer = setInterval(() => {
      setTimer(prevTimer => {
        if (prevTimer === 1) {
            clearInterval(intervalTimer);
            setIsDisabled(false);
            return 0;
        }
        return prevTimer - 1;
    });
  }, 1000);
      return () => clearInterval(intervalTimer);
  }, [timer])
    
  const submitOtpHandler = async (event) => {
    event.preventDefault();
    setLoading(true);
    const payload = {
      username: validateData.username,
      otp_code: otp.join(''),
      session: validateData.session,

    };
    try {
      const response = await axiosInstance.post("/validate_mfa_otp", payload);
        setLoading(false);
        
        if (response.data.statusCode !== 400) {
        const { accessToken, message, permissions, user_email,user_id,organization_id,country_id} = response.data.body; // No need to parse
        toast.success(message);
        sessionStorage.setItem("loginSession", accessToken);
        sessionStorage.setItem("accessToken", accessToken); 
        sessionStorage.setItem("useremail", user_email); // Save email from response
        sessionStorage.setItem("userId", user_id); // Save email from response
        setUserEmail(user_email); // Set email in AuthContext
        sessionStorage.setItem("organizationId",organization_id);
        sessionStorage.setItem("countryId",country_id);
        sessionStorage.setItem("mode", "DARK"); // Set theme mode
        if (permissions) {
            sessionStorage.setItem("permissions", JSON.stringify(permissions)); // Store permissions in session storage
            setPermissions(permissions); // Update permissions in context
        }
        sessionStorage.setItem("isAuthenticated", "true");
        setIsAuthenticated(true);
         navigate("/");
        } else {
          const responseBody = JSON.parse(response.data.body);
          const errMessage = responseBody.includes("Missing required parameters")
              ? "Please Enter OTP"
              : responseBody.includes("Invalid OTP")
              ? "Incorrect OTP"
              : responseBody.includes("Not authorized")
              ? "Token Expired"
              : responseBody
          toast.error(errMessage);
        }
        } catch (error) {
            setLoading(false);
            console.error(error);
            toast.error("Login failed, please try again.");
          }
      };

      const generateOtpHandler = async() => {
        // setLoading(true);
        const payload = {
          username,
          password
        };
      
        try {
          const response = await axiosInstance.post("/admin_login_users", payload);
          if (response.data.statusCode !== 400) {
            const { Session, ChallengeParameters } = response.data.body.response; 
            setValidateData({
              ...validateData, 
              session: Session,  
              username: ChallengeParameters.USER_ID_FOR_SRP,
              email: ChallengeParameters.CODE_DELIVERY_DESTINATION
            });
            setTimer(180);
            setIsDisabled(true)
          }
        } catch (error) {
          console.error(error);
          toast.error("Login failed, please try again.");
        }
      };

  return (
    <div className="valid-otp-wrapper">
      <ToastContainer autoClose={20000} />
      <div className="valid-otp-container">
          <>
            <h2>Verification Code</h2>
            <div className="">
              <span className="otp-email">{validateData.email ? `Email: ${validateData.email}`: ""}</span>
              <label className="otp-label">One-Time Access Code</label>
              {otp.map((value, index) => (
                <input
                key={index}
                id={`otp-input-${index}`}
                type="text"
                maxLength="1"
                autoComplete="off"
                value={value}
                onChange={(e) => handleOtpChange(e, index)}
                onKeyDown={(e) => handleBackspace(e, index)}
                className="otp-input"
              />

              ))}
            </div>
            <button className="btn btn-warning" onClick={submitOtpHandler}>
              {loading ? <BiLoader /> : "Submit"}
            </button>
          <div className="regenerate-section">

              <p className="resend-email">Didn't get the email? 
                <button onClick={generateOtpHandler} disabled={isDisabled} className="regenerate-btn">
                  Resend
                </button>
              </p>
              <p className="regenerate-timer">{isDisabled && `Wait ${formatTime(timer)} seconds to resend`}</p>
          </div>
        <p className="validswitchLogin" onClick={() => {
          setShowLoginPage(true);
          setShowOtpPage(false);
        }}>Back to Login</p>

          </>

      </div>
    </div>
  );
}

export default ValidOtp;